export { default } from './active-status-text';
